module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/down-2-cb58e6e76783200740f1eee01190458a.svg";